import Header from './components/Header';
import Home from './pages/Home';
import SpinOffer from './pages/SpinOffer';
import Success from './pages/Success';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <a href="https://www.mrhussain.in/portfolio/" className="back-btn">
        Back to Portfolio
      </a>
      <Router basename="/portfolio/spin-win">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/spin" element={<SpinOffer />} />
          <Route path="/success" element={<Success />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
